// extracted by mini-css-extract-plugin
export default {"container":"loading_container__T0sDN","icon":"loading_icon__8hYYb","loading":"loading_loading__1YKq8"};